import { Fragment, Suspense, useRef } from 'react'

import { Dialog, Transition } from '@headlessui/react'

import { ErrorBoundary } from '../../Error/ErrorBoundry.js'
import { useAdminSidebar } from '../AdminSidebarContext.js'
import { ScrollProvider, ScrollToTop } from '../ScrollProvider.js'

import { AdminSidebar } from './AdminSidebar.js'

export const AdminMenu = ({ children }) => {
  const containerRef = useRef<HTMLDivElement>()
  const { sidebarOpen, setSidebarOpen } = useAdminSidebar()

  return (
    <div className="flex h-full bg-background text-content-on-background overflow-hidden">
      <div className="hidden lg:block">
        <AdminSidebar />
      </div>
      <div className="flex-grow overflow-hidden">
        <div className="h-full flex flex-col" ref={containerRef}>
          <Transition.Root show={sidebarOpen} as={Fragment}>
            <Dialog
              as="div"
              className="fixed inset-0 z-40 flex lg:hidden"
              onClose={setSidebarOpen}
            >
              <Transition.Child
                as={Fragment}
                enter="transition-opacity ease-linear duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity ease-linear duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-surface-600 bg-opacity-75" />
              </Transition.Child>
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <div className="relative max-w-md bg-main-50 flex-1 flex flex-col">
                  <div className="flex-shrink-0 flex h-full">
                    <AdminSidebar onSelect={() => setSidebarOpen(false)} />
                  </div>
                </div>
              </Transition.Child>
            </Dialog>
          </Transition.Root>
          <div className="flex-1 overflow-auto">
            <ScrollProvider scrollRef={containerRef}>
              <ScrollToTop />
              <ErrorBoundary>
                <Suspense fallback={<></>}>{children}</Suspense>
              </ErrorBoundary>
            </ScrollProvider>
          </div>
        </div>
      </div>
    </div>
  )
}
